import { Sidebar, useSidebarState } from 'react-admin';
import { useIsMobileSidebar } from '../../hooks/useIsMobileSidebar';

export const MySidebar = (props: any) => {
  const [open] = useSidebarState();
  const isXSmall = useIsMobileSidebar();

  return (
    <Sidebar
      {...props}
      anchor={isXSmall ? 'right' : 'left'}
      ModalProps={{ disableScrollLock: true }}
      sx={{
        ...(isXSmall
          ? null
          : {
            width: open ? 'var(--sidebar-width)' : 0,
            flexShrink: 0,
            overflow: 'hidden',
            borderRight: open ? '1px solid var(--color-border)' : 'none',
            backgroundColor: 'var(--color-surface)',
            boxShadow: 'none',
            transition: 'width var(--dur-base) var(--ease-standard)',
            '& .RaSidebar-fixed': {
              top: 'var(--appbar-height)',
              height: 'calc(100dvh - var(--appbar-height))',
              width: open ? 'var(--sidebar-width)' : 0,
              overflowX: 'hidden',
              backgroundColor: 'var(--color-surface)',
              transition: 'width var(--dur-base) var(--ease-standard)',
            },
          }),
        '& .MuiDrawer-paper': {
          width: 'var(--sidebar-width) !important',
          height: '100dvh',
          borderRight: 'none',
          /* Przy prawym anchorze widoczna jest lewa krawedz panelu. */
          borderLeft: isXSmall ? '1px solid var(--color-border)' : 'none',
          boxShadow: 'none',
          backgroundImage: 'none',
        },
        '& .MuiList-root': {
          p: 'var(--space-3)',
          width: 'var(--sidebar-width)',
          gap: '2px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    />
  );
};
